import React from 'react';

interface TrapezoidHandleProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  onMouseDown?: React.MouseEventHandler<HTMLDivElement>;
}

const TrapezoidHandle: React.FC<TrapezoidHandleProps> = ({ className = '', onMouseDown, ...props }) => {
  return (
    <div
      onMouseDown={onMouseDown}
      {...props}
      className={`
        absolute -top-[1px] left-1/2 -translate-x-1/2 
        w-32 h-6 z-20
        cursor-move flex justify-center items-start 
        group/handle 
        ${className}
      `}
    >
      <div
        className={`
          w-24 h-2 
          bg-zinc-200 dark:bg-[#222224] border-b border-zinc-200 dark:border-gray-700 
          transition-all duration-300 
          flex justify-center items-center 
          
          /* Hover States */
          group-hover/handle:bg-blue-500/30 dark:group-hover/handle:bg-blue-700/20 
          group-hover/handle:shadow-[0_0_15px_rgba(29,78,216,0.2)]
          group-active/handle:bg-blue-500/60 dark:group-active/handle:bg-blue-700/30
        `}
        style={{ clipPath: 'polygon(0 0, 100% 0, 85% 100%, 15% 100%)' }}
      >
        <div className="w-8 h-0.5 bg-zinc-400 dark:bg-gray-500/50 dark:group-hover/handle:bg-white transition-colors" />
      </div>
    </div>
  );
};

export default TrapezoidHandle;
